import React, { Component } from 'react';
// import mockup from './images/mockup.png';
import massively from './images/massively.png';
import forty from './images/forty.png';
import ethereal from './images/ethereal.png';
import chef from './images/chef.png';
import './App.css';

class App extends Component {
    render() {
    return (
            <div className="App">
                <header>
                    <div className="container">
                        <h1>Simple, yet beautiful,<br/> websites you can afford</h1>
                        <p className="intro">For just $29 per month, you can have a custom themed website for your business.</p>
                        <button><a href="#themes">View themes</a></button>
                    </div>
                </header>
                <div className="about">
                    <div className="container">
                        <h2>For just $29 per month, we offer a simple website for your business based off of a pre-built theme with no huge upfront costs. We will add your logo, change the colors, add your custom copy and change out some images at no additional cost.</h2>
                    </div>
                </div>
                <div className="themes" id="themes">
                    <h1>Themes</h1>
                    <div className="columns">
                        <div className="column theme ethereal">
                            <img src={ethereal} />
                            <a href="https://ethereal.parkeragee.com" target="_blank" rel="noopener noreferrer">View demo</a>
                        </div>
                        <div className="column theme forty">
                            <img src={forty} />
                            <a href="https://forty.parkeragee.com" target="_blank" rel="noopener noreferrer">View demo</a>
                        </div>
                        <div className="column theme massively">
                            <img src={massively} />
                            <a href="https://massively.parkeragee.com" target="_blank" rel="noopener noreferrer">View demo</a>
                        </div>
                    </div>
                    <div className="columns">
                        <div className="column theme chef">
                            <img src={chef} />
                            <a href="https://demos.hogash.com/phaeton-restaurant-html/" target="_blank" rel="noopener noreferrer">View demo</a>
                        </div>
                        <div className="column"></div>
                        <div className="column"></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js